<template>
  <div class="memory_box">
    <div></div>
    <div class="memory_main">
      <div style=""></div>
      <div class="memory-head" style="z-index: 10;">
        <div>
          <!-- <audio ref="audio1" src="../../assets/jnt/music.mp3" loop="" autoplay=""></audio> -->
        </div>
        <div class="memory-head-left" style="top:0.5vw;">
          <div class="left-back" @click="back" :style="getColorTop()">
            <span class="back-icon"></span>
          </div>
          <div @click="goto('/jnt')" class="left-home" :style="getColorTop()">
            <span class="home-icon"></span>
          </div>
        </div>
        <div class="center-info" style="top:2.8vw;">
          <div class="family-slide flex">
            <div
              v-if="hall.myId == $store.getters.userId"
              class="family-btn"
              :style="getColorTop()"
            >
              <span @click="invite()">邀请亲友</span>
            </div>
            <div v-else class="family-btn" :style="getColorTop()">
              <span @click="addFriend(hall.id)" v-if="!isFriend">加入亲友团</span>
              <span v-else>已加入亲友团</span>
            </div>
          </div>
          <div class="follow-icon-wrap" :style="getColorTop()">
            <i class="follow-icon follow-no" @click="addCollect(hall.id)" v-if="!isCollect"></i>
            <i class="follow-icon follow-yes" v-else @click="delCollect(hall.id)"></i>
          </div>
        </div>
        <div @click="controlAudio" class="memory-head-right" style="top:0.5vw;">
          <div class="music-wrap" :style="getColorTop()">
            <span :class="isPlaying ? 'music-icon turn' : 'music-icon'"></span>
          </div>
          <div @click="invite()" class="right-share" :style="getColorTop()">
            <span class="share-icon"></span>
          </div>
          <div @click="menuFlag = !menuFlag" class="right-menu" :style="getColorTop()">
            <span class="menu-icon"></span>
          </div>
        </div>
        <div v-if="menuFlag">
          <div class="box_mask"></div>
          <div class="right-menu-row">
            <div
              @click="goto('/jnt/history?category=' + activeName + '&hallId=' + hall.id)"
              class="menu-item item-line"
            >
              <i class="icon icon-pray"></i><span class="txt">供奉记录</span>
            </div>

            <div
              v-if="hall.myId == $store.getters.userId"
              @click="goto('/jnt/set/' + hall.id)"
              class="menu-item item-line"
            >
              <i class="icon icon-kefu"></i><span class="txt">纪念馆设置</span>
            </div>
            <div
              v-if="hall.myId == $store.getters.userId"
              @click="goto('/jnt/friends/' + hall.id)"
              class="menu-item item-line"
            >
              <i class="icon icon-qa"></i><span class="txt">亲友团管理</span>
            </div>
            <div @click="goto('/jnt/Setting')" class="menu-item item-line">
              <i class="icon icon-kefu"></i><span class="txt">联系客服</span>
            </div>
            <div @click="goto('/jnt/help')" class="menu-item item-line">
              <i class="icon icon-qa"></i><span class="txt">帮助反馈</span>
            </div>
            <div @click="goto('/jnt/complain')" class="menu-item">
              <i class="icon icon-complain"></i><span class="txt">投诉</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="head-tabNav-wrap">
          <div class="tabNav-con">
            <div
              v-if="type == 'siren'"
              @click="activeName = 1"
              :class="
                activeName == 1
                  ? activeName == 1
                    ? jntTemplateId == 2 || jntTemplateId == 3 || jntTemplateId == 5
                      ? 'tabNav-con-item activeBlack'
                      : 'tabNav-con-item activeWhite'
                    : myTemplateId == 1 || myTemplateId == 2 || myTemplateId == 3
                    ? 'tabNav-con-item activeBlack'
                    : 'tabNav-con-item activeWhite'
                  : 'tabNav-con-item'
              "
              :style="getColor()"
            >
              纪念馆
            </div>
            <div
              v-if="type == 'siren'"
              @click="activeName = 2"
              :class="
                activeName == 2
                  ? activeName == 1
                    ? jntTemplateId == 2 || jntTemplateId == 3 || jntTemplateId == 5
                      ? 'tabNav-con-item activeBlack'
                      : 'tabNav-con-item activeWhite'
                    : myTemplateId == 1 || myTemplateId == 2 || myTemplateId == 3
                    ? 'tabNav-con-item activeBlack'
                    : 'tabNav-con-item activeWhite'
                  : 'tabNav-con-item'
              "
              :style="getColor()"
            >
              墓园
            </div>
          </div>
        </div>
      </div>
      <div>
        <router-view
          :hallGoodsList="hallGoodsList"
          :hall_sacrifice_list="hall_sacrifice_list"
          :jntTemplateId="jntTemplateId"
          :myTemplateId="myTemplateId"
          :msg="msg"
        ></router-view>
      </div>
    </div>
    <div v-if="shareFlag">
      <div class="shareBox" style="background: rgba(0, 0, 0, 0.9);">
        <div class="arraw"></div>
        <div class="tip-content">点击右上角分享好友，共同悼念、缅怀！</div>
        <div class="flex btn-close" @click="shareFlag = false">
          <span class="icon-close"></span>
        </div>
      </div>
    </div>
    <!-- <van-action-sheet v-model="jipinFlag" title="祭品" style="height: 583px;"> -->
    <div v-if="jipinFlag">
      <div
        class="mt-offcanvas active mt-offcanvas-bottom mt-offcanvas-bottom__show"
        style="height: 583px; z-index: 2000;"
      >
        <div class="mt-offcanvas-inner" style="height: 583px; z-index: 2000;">
          <div class="inner-box " style="height: 100%; background-color: transparent;">
            <div class="inner-box-txt inner-box-radius">祈福祭品</div>
            <div style="overflow: auto;">
              <div class="pray_goods_box" style="height: 583px;">
                <div class="goods_nav swiper-container-vertical swiper-container-free-mode">
                  <div
                    class="swiper-wrapper"
                    style="transform: translate3d(0px, 0px, 0px); transition-duration: 300ms;"
                  >
                    <template v-for="(item, index) in hallCategories">
                      <div
                        :class="
                          hallSelectCategory.value == item.value
                            ? 'swiper-slide goods_nav_slide active '
                            : 'swiper-slide goods_nav_slide '
                        "
                        style="height: 45px;"
                        :key="index"
                        @click="changeHallCategory(item)"
                      >
                        <span>{{ item.label }}</span>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="goods_content scroll-auto"
                  id="goodsContent"
                  style="max-height: 476px; overflow-y: auto;"
                >
                  <!-- <div v-if="hallSelectCategory.value != 'package'" class="package_head-box">
                    <img
                      src="../../assets/jnt/taocan.jpg"
                      style="border-radius:5px;margin:.5rem;width:100%;"
                      @click="hallSelectCategory.value = 'package'"
                    />
                  </div> -->
                  <!-- 套餐 -->
                  <!-- <div
                    v-if="hallSelectCategory.value == 'package'"
                    class="package_head_nav"
                    style=""
                  >
                    <div
                      @click="changeHallSpecs(item)"
                      v-for="(item, index) in hallSpecs"
                      :key="index"
                      :class="
                        item.value == hallSelectPackage.value
                          ? 'package_head_nav-item active'
                          : 'package_head_nav-item'
                      "
                    >
                      <span>{{ item.label }}</span>
                    </div>
                    <span class="package_head_nav-tips"
                      >{{ hallSelectPackage.label }}包含以下{{ hallCurrentList.length }}件祭品</span
                    >
                  </div> -->

                  <template v-for="(item, index) in hallCurrentList">
                    <div class="goods_content-item" :key="index" @click="addHallCart(item)">
                      <span :class="getClass(item.id, 'hall')"><img :src="item.firstPhoto"/></span>
                      <span class="name">{{ item.proName }}</span>
                      <span class="price free" v-if="item.price == 0">免费</span>
                      <span class="price charge" v-else>{{ item.price }}元</span>
                    </div>
                  </template>
                </div>
              </div>
              <!-- 单个购买底部 -->
              <div v-if="hallSelectCategory != 'package'" class="goods_footer top_line">
                <div class="goods_footer-row">
                  <div class="row-left flex">
                    <div class="goods-sel flex arrow-bottom" style="display: flex; opacity: 1;">
                      <div @click="hallLook()" class="txt">
                        <span class="txt1 font12"
                          ><span class="TextChangeToOneLines"
                            >已选(<span class="txt1-t">
                              <template v-for="(item, index) in hallGoodsCart">
                                <span :key="index">{{ item.proName }}</span>
                              </template>
                            </span></span
                          >)</span
                        >
                      </div>
                      <div v-if="hallSelectList">
                        <div @click="hallLook()" class="box_mask"></div>
                        <div class="goods_selected_visible_menu" style="opacity: 1; z-index: 10;">
                          <div class="title bottom-line">已选祭品</div>
                          <ul class="menu-row">
                            <template v-for="(item, index) in hallGoodsCart">
                              <li class="item flex" :key="index">
                                <div class="title">{{ item.proName }}</div>
                                <div class="price"><em>￥</em>{{ item.price }}</div>
                                <i class="del" @click="delHallCart(item)"></i>
                              </li>
                            </template>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row-right flex" style="">
                    <div class="goods-total">
                      <span class="txt">合计：{{ hallGoodsSum }}.00元</span>
                    </div>

                    <div class="buy-btn" style="background: rgb(228, 128, 60);">
                      <span class="txt" @click="submitHallPay()">供奉</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 套餐购买底部 -->
              <div v-else class="package_head">
                <div class="content">
                  <span class="del" id="packageOriginalPrice2">原价: 77.00元</span>
                  <div class="price large_size" style="color: rgb(228, 128, 60);" id="priceSale">
                    现价: 29.90元
                  </div>
                  <span class="buy-btn buyPackageBtn" style="background: rgb(228, 128, 60);"
                    >供奉</span
                  >
                </div>
              </div>
            </div>
            <i @click="closeHallJipin" class="inner-box-close inner-box-close__right"></i>
          </div>
        </div>
      </div>
      <div class="mt-offcanvas-mask"></div>
    </div>
    <div v-if="muyuanFlag">
      <div
        class="mt-offcanvas active mt-offcanvas-bottom mt-offcanvas-bottom__show"
        style="height: 583px; z-index: 2000;"
      >
        <div class="mt-offcanvas-inner" style="height: 583px; z-index: 2000;">
          <div class="inner-box " style="height: 100%; background-color: transparent;">
            <div class="inner-box-txt inner-box-radius">祈福祭品</div>
            <div style="overflow: auto;">
              <div class="pray_goods_box" style="height: 583px;">
                <div class="goods_nav swiper-container-vertical swiper-container-free-mode">
                  <div
                    class="swiper-wrapper"
                    style="transform: translate3d(0px, 0px, 0px); transition-duration: 300ms;"
                  >
                    <template v-for="(item, index) in memCategories">
                      <div
                        :class="
                          memSelectCategory.value == item.value
                            ? 'swiper-slide goods_nav_slide active '
                            : 'swiper-slide goods_nav_slide '
                        "
                        style="height: 45px;"
                        :key="index"
                        @click="changeMemCategory(item)"
                      >
                        <span>{{ item.label }}</span>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="goods_content scroll-auto"
                  id="goodsContent"
                  style="max-height: 476px; overflow-y: auto;"
                >
                  <!-- <div v-if="memSelectCategory.value != 'package'" class="package_head-box">
                    <img
                      src="../../assets/jnt/taocan.jpg"
                      style="border-radius:5px;margin:.5rem;width:100%;"
                      @click="memSelectCategory.value = 'package'"
                    />
                  </div> -->
                  <!-- 套餐 -->
                  <!-- <div
                    v-if="memSelectCategory.value == 'package'"
                    class="package_head_nav"
                    style=""
                  >
                    <div
                      @click="changeMemSpecs(item)"
                      v-for="(item, index) in memSpecs"
                      :key="index"
                      :class="
                        item.value == memSelectPackage.value
                          ? 'package_head_nav-item active'
                          : 'package_head_nav-item'
                      "
                    >
                      <span>{{ item.label }}</span>
                    </div>
                    <span class="package_head_nav-tips"
                      >{{ memSelectPackage.label }}包含以下{{ memCurrentList.length }}件祭品</span
                    >
                  </div> -->
                  <template v-for="(item, index) in memCurrentList">
                    <div class="goods_content-item" :key="index" @click="addMemCart(item)">
                      <span :class="getClass(item.id, 'mem')"><img :src="item.firstPhoto"/></span>
                      <span class="name">{{ item.proName }}</span>
                      <span class="price free" v-if="item.price == 0">免费</span>
                      <span class="price charge" v-else>{{ item.price }}元</span>
                      <span class="child-item-time"
                        ><i class="icon-clock"></i>{{ item.proDuration }}天</span
                      >
                    </div>
                  </template>
                </div>
              </div>
              <!-- 单个购买底部 -->
              <div v-if="memSelectCategory != 'package'" class="goods_footer top_line">
                <div class="goods_footer-row">
                  <div class="row-left flex">
                    <div class="goods-sel flex arrow-bottom" style="display: flex; opacity: 1;">
                      <div @click="memLook()" class="txt">
                        <span class="txt1 font12"
                          ><span class="TextChangeToOneLines"
                            >已选(<span class="txt1-t">
                              <template v-for="(item, index) in memGoodsCart">
                                <span :key="index">{{ item.proName }}</span>
                              </template>
                            </span></span
                          >)</span
                        >
                      </div>
                      <div v-if="memSelectList">
                        <div @click="memLook()" class="box_mask"></div>
                        <div class="goods_selected_visible_menu" style="opacity: 1; z-index: 10;">
                          <div class="title bottom-line">已选祭品</div>
                          <ul class="menu-row">
                            <template v-for="(item, index) in memGoodsCart">
                              <li class="item flex" :key="index">
                                <div class="title">{{ item.proName }}</div>
                                <div class="price"><em>￥</em>{{ item.price }}</div>
                                <i class="del" @click="delMemCart(item)"></i>
                              </li>
                            </template>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row-right flex" style="">
                    <div class="goods-total">
                      <span class="txt">合计：{{ memGoodsSum }}.00元</span>
                    </div>
                    <div class="buy-btn" style="background: rgb(228, 128, 60);">
                      <span class="txt" @click="submitMemPay()">供奉</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 套餐购买底部 -->
              <div v-else class="package_head">
                <div class="content">
                  <span class="del" id="packageOriginalPrice2">原价: 77.00元</span>
                  <div class="price large_size" style="color: rgb(228, 128, 60);" id="priceSale">
                    现价: 29.90元
                  </div>
                  <span class="buy-btn buyPackageBtn" style="background: rgb(228, 128, 60);"
                    >供奉</span
                  >
                </div>
              </div>
            </div>
            <i @click="closeMemJipin" class="inner-box-close inner-box-close__right"></i>
          </div>
        </div>
      </div>
      <div class="mt-offcanvas-mask"></div>
    </div>
    <!-- </van-action-sheet> -->
    <!-- <van-action-sheet v-model="messageListFlag" title="留言"> -->
    <div v-if="messageListFlag">
      <div
        class="mt-offcanvas active mt-offcanvas-bottom mt-offcanvas-bottom__show"
        style="z-index: 2000;"
      >
        <div class="mt-offcanvas-inner" style="z-index: 2000;">
          <div class="inner-box inner-box-radius" style="height: 100%;">
            <div style="overflow: auto;">
              <div class="pray_msg_list_box">
                <div class="top-txt" style="color: rgb(228, 128, 60);">
                  全部留言({{ message_total }})
                </div>

                <div class="msg_list-row" id="msg_list-row" style="height: 26rem;">
                  <template v-for="(item, index) in messageList">
                    <div class="msg_list-item" :key="index">
                      <img class="headimg" :src="$properties(item.myProfile, 'headImgUrl')" />
                      <div class="info" style="width: 100%;">
                        <div class="name">
                          {{ $properties(item.myProfile, 'nickname') }}
                          <span
                            class="card-private"
                            v-if="$properties(item.accessType, 'value') == 'private'"
                            ><i class="icon-private"></i>仅自己可见</span
                          >
                        </div>
                        <div class="content">{{ item.content }}</div>
                        <div class="time">刚刚</div>
                      </div>
                    </div>
                  </template>
                  <div class="scroll-auto" style="height: 26rem;">
                    <div
                      class="am-list am-list-view-scrollview"
                      style="position: relative; overflow: auto; height: 26rem;"
                    >
                      <div
                        class="am-list-view-scrollview-content am-list"
                        style="position: absolute; min-width: 100%;"
                      >
                        <div class="am-list-body"></div>
                        <div class="am-list-footer">
                          <div style="padding: 5px; text-align: center;">没有更多数据了</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg_list-footer top_line flex flex_center">
                  <div @click="messageEdit" class="msg-bg flex flex_center">
                    <span class="txt icon-edit">留言寄托对逝者的思念~</span>
                  </div>
                  <div @click="messageEdit" class="msg-btn flex_center">
                    <span class="txt" style="background: rgb(228, 128, 60);">留言</span>
                  </div>
                </div>
              </div>
            </div>
            <i
              @click="messageClose('list')"
              class="inner-box-close inner-icon-close inner-box-close__right"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <!-- </van-action-sheet> -->

    <!-- <van-action-sheet v-model="messageEditFlag" title="填写留言"> -->
    <div v-if="messageEditFlag">
      <div
        class="mt-offcanvas mt-offcanvas_mask-transparent active mt-offcanvas-bottom mt-offcanvas-bottom__show"
        style="z-index: 2000;"
      >
        <div class="mt-offcanvas-inner" style="z-index: 2000;">
          <div class="inner-box inner-box-radius" style="height: 100%;">
            <div style="overflow: auto;">
              <div class="pray_msg_box">
                <div class="msg_top-txt" style="color: rgb(228, 128, 60);">我想对他（她）说：</div>
                <div class="msg_textarea">
                  <textarea
                    class="txt"
                    placeholder="输入您的思念寄语"
                    v-model="message_form.content"
                  ></textarea>
                </div>
                <div class="msg_change">
                  <span class="msg_change-txt">常用语</span
                  ><span class="msg_change-btn" @click="randomUsually()">换一批</span>
                </div>
                <ul class="msg_row" id="msgTagList">
                  <template v-for="(item, index) in usually_list">
                    <li
                      @click="changeUsually(index)"
                      :class="
                        usually_selected == index
                          ? 'msg_row-item icon-selected'
                          : 'msg_row-item icon-default'
                      "
                      :key="index"
                    >
                      {{ item.content }}
                    </li>
                  </template>
                  <!-- <li class="msg_row-item icon-default">我爱您</li>
                  <li class="msg_row-item icon-default">
                    我对你的思念，就是不断地和身边的人提起你
                  </li> -->
                </ul>
                <div class="msg_visible">
                  <div @click.stop="kejian" class="msg_visible_item">
                    <span class="txt1">谁可以看</span><span class="txt2 arrow-top">公开</span>
                  </div>
                  <div v-if="viFlag">
                    <div @click.stop="kejian" class="box_mask"></div>
                    <div class="msg_visible_menu" style="opacity: 1;">
                      <div class="title bottom-line">谁可以看</div>
                      <ul>
                        <li class="item bottom-line" @click="setCategory('public')">
                          <i
                            :class="
                              message_form.category == 'public' ? 'icon-selected' : 'icon-default'
                            "
                          ></i>
                          <div class="txt">
                            <div class="txt1 selected">公开</div>
                            <div class="txt2">所有人可见</div>
                          </div>
                        </li>
                        <li class="item" @click="setCategory('private')">
                          <i
                            :class="
                              message_form.accessType == 'private'
                                ? 'icon-selected'
                                : 'icon-default'
                            "
                          ></i>
                          <div class="txt"><div class="txt1">仅自己可见</div></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span class="msg-num">已有{{ messageTotal }}人留言</span>
                </div>
                <div class="msg_footer">
                  <div
                    class="btn-submit"
                    style="background: rgb(228, 128, 60);"
                    @click="submitMessage"
                  >
                    <span class="txt">提交留言</span>
                  </div>
                </div>
              </div>
            </div>
            <i
              @click="messageClose('edit')"
              class="inner-box-close inner-icon-close inner-box-close__right"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <!-- </van-action-sheet> -->
    <van-action-sheet v-model="aboutFlag" title="简介">
      <div class="content" style="padding: 2rem 2rem 4rem 2rem;line-height: 1rem;">
        {{ hall.content }}
      </div>
    </van-action-sheet>
    <!-- 分享 -->
    <div class="invite-friends-pop" v-if="popFlag">
      <span
        @click="closePop()"
        style="z-index:999;color:#ffffff;position: absolute;top: 2rem;right: 2rem;font-size: 3rem;"
        class="icon iconfont"
        >&#xed1a;</span
      >
      <div class="invite-friends-wrap" style="height: 656px;">
        <img class="share-img" :src="shareImg" />
      </div>
    </div>
    <!-- 分享 -->
  </div>
</template>

<script>
import bus from '../../common/bus'
import { pay } from '@/api/PayModel'

export default {
  name: 'mourn',
  data() {
    return {
      msg: [],
      popFlag: false,
      hall_sacrifice_list: [], //纪念馆滚动供奉记录
      jntTemplateId: 5,
      myTemplateId: 1,
      // selectTaocan: '元宵节套餐',
      activeName: 1,
      menuFlag: false,
      shareFlag: false,
      isPlaying: true,
      bgImg: require('../../assets/jnt/taocan.jpg'),
      jipinFlag: false,
      muyuanFlag: false,
      taocanFlag: false,
      messageEditFlag: false,
      messageListFlag: false,
      viFlag: false,
      aboutFlag: false,
      id: null,
      type: null,
      hall: {
        id: null,
        myId: null,
        hallCount: 1,
        firstPhoto: '',
        secondPhoto: '',
        candleCount: 0,
        content: null,
        hallBackground: 1,
        memBackground: 5,
        musicBackground: 0,
      },
      messageList: [],
      messageTotal: 0,
      message_form: {
        hallId: 0,
        accessType: 'public',
        content: '',
        myId: this.$store.getters.userId,
      },
      usually_list: [],
      usually_page: 1,
      usually_total: 0,
      usually_selected: -1,
      sacrifice_list: [],
      sacrifice_active: 'all',
      // taocanData: ['元宵节套餐', '新年套餐', '思念套餐', '追思套餐', '永恒套餐'],
      isCollect: false,
      isFriend: false,
      hallSelectList: false,
      hallSelectCategory: { value: '' },
      hallSelectPackage: {},
      hallCategories: [],
      hallSpecs: [],
      hallGoodsList: [],
      hallCurrentList: [],
      hallGoodsCart: [],
      hallGoodsSum: 0,
      hallGoodsNum: 0,
      hallForm: {
        myId: this.$store.getters.userId,
        goodsList: [],
        hallId: null,
        category: null,
      },
      memSelectList: false,
      memSelectCategory: { value: '' },
      memSelectPackage: {},
      memCategories: [],
      memSpecs: [],
      memGoodsList: [],
      memCurrentList: [],
      memGoodsCart: [],
      memGoodsSum: 0,
      memGoodsNum: 0,
      memForm: {
        myId: this.$store.getters.userId,
        goodsList: [],
        hallId: null,
      },
      shareImg: '',
      shareUrl: '',
    }
  },
  created() {
    this.jntTemplateId = this.hall.hallBackground - 1
    this.myTemplateId = this.hall.memBackground - 1
    var params = this.$route.params
    this.id = params.id
    this.type = params.type
    this.hall.id = this.id
    this.memForm.hallId = this.id
    this.hallForm.hallId = this.id
    this.message_form.hallId = this.id
    let _url = this.$route.fullPath
    if (_url.indexOf('mourn') > -1) {
      this.activeName = 1
    } else {
      this.activeName = 2
    }
    bus.$off('jipin')
    bus.$on('jipin', msg => {
      this.jipinFlag = true
      console.log(msg)
    })
    bus.$off('muyuan')
    bus.$on('muyuan', msg => {
      this.muyuanFlag = true
      console.log(msg)
    })
    bus.$off('messageList')
    bus.$on('messageList', msg => {
      this.messageListFlag = true
      console.log(msg)
    })
    bus.$off('about')
    bus.$on('about', msg => {
      this.aboutFlag = true
      console.log(msg)
    })
    bus.$off('share')
    bus.$on('share', msg => {
      if (msg == 'open') {
        this.shareFlag = true
      }
    })
    this.queryHallOne()
    this.queryMyCollect()
    this.queryHallCategory()
    this.queryMemCategory()

    bus.$off('queryHallCandle')
    bus.$on('queryHallCandle', () => {
      console.log('queryHallCandle')
      this.queryHallCandle()
    })
  },
  mounted() {
    this.queryUsually()
    this.queryMessage()
    this.queryHallSpecs()
    this.queryHallGoodsAll()
    this.queryHallCandle()
    this.queryHallMessage()
    this.queryMemSpecs()
    this.queryMemGoodsAll()
    let audio = this.$refs.audio1
    if (audio) {
      audio.play()
      this.isPlaying = true
    }
    
  },
  methods: {
    closePop() {
      this.popFlag = false
    },
    invite() {
      this.popFlag = true
      this.shareImg = 'http://' + window.location.host + '/api/image/share/' + this.hall.id + '.png'
      this.shareUrl = this.$route.fullPath
      //this.shareUrl =
      // background-image: url("/api/image/share/1.png");
    },
    getClass(id, str) {
      let _class = 'img'
      if (str == 'hall') {
        this.hallGoodsCart.map(item => {
          if (item.id == id) {
            _class = 'img selected'
          }
        })
      } else {
        this.memGoodsCart.map(item => {
          if (item.id == id) {
            _class = 'img selected'
          }
        })
      }

      return _class
    },
    getColorTop() {
      let _color = 'background: rgba(255, 255, 255, 0.2);'
      if (this.activeName == 2) {
        if (this.myTemplateId == 1 || this.myTemplateId == 2 || this.myTemplateId == 3) {
          _color = 'background: #0006'
        }
      } else {
        if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
          _color = 'background: #0006'
        }
      }

      return _color
    },
    getColor() {
      let _color = 'color: rgb(255, 255, 255);opacity:1;'
      if (this.activeName == 2) {
        if (this.myTemplateId == 1 || this.myTemplateId == 2 || this.myTemplateId == 3) {
          _color = 'color: #333 !important;opacity:1;'
        }
      } else {
        if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
          _color = 'color: #333 !important;opacity:1;'
        }
      }

      return _color
    },
    queryMyCollect() {
      var that = this
      this.$query(
        '/api/hall/queryMyCollect',
        { hallId: this.id, myId: this.$store.getters.userId },
        function(res) {
          that.isCollect = res['isCollect']
          that.isFriend = res['isFriend']
        }
      )
    },
    queryHallCandle() {
      var that = this
      this.$queryAll(
        'HallHistory',
        {
          sourceType: 'hall',
          'hallInfo.id': 'isnotnull',
          'myProfile.id': 'isnotnull',
          hallId: this.id,
          size: 30,
          sort: { createDate: 0 },
        },
        ['id,sourceSubtype,content,targetPhoto,myProfile.nickname,myProfile.headImgUrl'],
        function(res) {
          for (var index in res.data) {
            var item = res.data[index]
            that.hall_sacrifice_list.push({
              img: item.myProfile.headImgUrl,
              nicheng: item.myProfile.nickname,
              content: item.content,
              sourceSubtype: item.sourceSubtype,
              targetPhoto: item.targetPhoto,
            })
          }
        }
      )
    },
    queryHallMessage() {
      var that = this
      this.$queryAll(
        '/api/hallmessage/queryRolling',
        {
          hallId: this.id,
          myId: that.$store.getters.userId,
          sort: { createDate: 0 },
        },
        ['id,content,myProfile.nickname,myProfile.headImgUrl'],
        function(res) {
          that.msg = []
          for (var index in res.data) {
            var item = res.data[index]
            that.msg.push({
              img: item.myProfile.headImgUrl,
              nicheng: item.myProfile.nickname,
              con: item.content,
            })
          }
        }
      )
    },
    queryHallCategory() {
      var that = this
      this.hallCategories = [{ value: '', label: '所有' }]
      var codelist = this.$store.getters.codelist['GOODS_HALL_TYPE']
      Object.keys(codelist).forEach(function(key) {
        that.hallCategories.push({ value: key, label: codelist[key] })
      })
    },
    changeHallCategory(category) {
      this.hallSelectCategory = category
      this.hallSelectPackage = {}
      this.hallCurrentList = []
      let _hallCurrentList = []
      for (var i = 0; i < this.hallGoodsList.length; i++) {
        if (
          !this.hallSelectCategory.value ||
          (this.hallGoodsList[i].hallType &&
            this.hallGoodsList[i].hallType.value == this.hallSelectCategory.value)
        ) {
          _hallCurrentList.push(this.hallGoodsList[i])
        }
      }
      this.hallCurrentList = _hallCurrentList
    },
    queryHallSpecs() {
      var that = this
      this.hallSpecs = []
      var codelist = this.$store.getters.codelist['GOODS_HALL_SPECS']
      Object.keys(codelist).forEach(function(key) {
        that.hallSpecs.push({ value: key, label: codelist[key] })
      })
    },
    changeHallSpecs(specs) {
      this.hallSelectPackage = specs
      this.hallCurrentList = []
      for (var i = 0; i < this.hallGoodsList.length; i++) {
        if (
          !this.hallSelectCategory.value ||
          (this.hallGoodsList[i].hallType &&
            this.hallGoodsList[i].hallType.value == this.hallSelectCategory.value)
        ) {
          if (
            !this.hallSelectPackage.value ||
            (this.hallGoodsList[i].hallSpecs &&
              this.hallGoodsList[i].hallSpecs.value == this.hallSelectPackage.value)
          ) {
            this.hallCurrentList.push(this.hallGoodsList[i])
          }
        }
      }
    },
    queryHallGoodsAll() {
      var that = this
      this.$queryAll(
        'ProGoods',
        { channel: 'hall', sort: { orderNum: 1 } },
        ['id,proName,hallType,firstPhoto,price,hallSpecs,proDuration'],
        function(res) {
          if (that.type != 'siren') {
            for (var item in res.data) {
              res.data[item].price = 0
            }
          }
          that.$fill(that.hallGoodsList, res.data)
          that.$fill(that.hallCurrentList, res.data)
        }
      )
    },
    addHallCart(item) {
      var existFlag = false
      for (var j = 0; j < this.hallGoodsCart.length; j++) {
        if (item.id == this.hallGoodsCart[j]['id']) {
          existFlag = true
          this.hallGoodsCart.splice(j, 1)
          break
        }
      }
      if (!existFlag) {
        this.hallGoodsCart.push(item)
      }
      this.calcHallCart()
    },
    delHallCart(item) {
      for (var j = 0; j < this.hallGoodsCart.length; j++) {
        if (item.id == this.hallGoodsCart[j].id) {
          this.hallGoodsCart.splice(j--, 1)
        }
      }
      this.calcHallCart()
    },
    calcHallCart() {
      var hallGoodsSum = 0
      var hallGoodsNum = 0
      for (var j = 0; j < this.hallGoodsCart.length; j++) {
        hallGoodsSum = hallGoodsSum + this.hallGoodsCart[j].price
        hallGoodsNum = hallGoodsNum + 1
      }
      this.hallGoodsSum = hallGoodsSum
      this.hallGoodsNum = hallGoodsNum
    },
    submitHallPay() {
      this.hallForm.goodsList = []
      for (var i = 0; i < this.hallGoodsCart.length; i++) {
        this.hallForm.goodsList.push({
          goodsId: this.hallGoodsCart[i].id,
          price: this.hallGoodsCart[i].price,
          count: 1,
        })
      }
      let _type, _imgList
      if (this.hallGoodsCart.length == 1) {
        _type = 1
      } else if (this.hallGoodsCart.length > 1) {
        _type = 2
      }
      _imgList = []
      this.hallGoodsCart.map(item => {
        _imgList.push(item.firstPhoto)
      })
      var that = this
      this.hallForm.hallId = this.id
      this.hallForm.category = this.type
      this.$submit('/api/order/addOrderWithHall', this.hallForm, function(res) {
        if (res.code === 1) {
          var param = {
            orderNo: res.data.orderNo,
            myId: that.$store.getters.userId,
            openid: that.$store.getters.user['openid'],
          }
          pay(param, function(code, msg) {
            // 成功
            if (code == 1 || code == 2) {
              that.$toast('支付成功')
              that.hallGoodsCart = []
              that.jipinFlag = false
              setTimeout(() => {
                bus.$emit('fire', { type: _type, data: _imgList })
              }, 1000)
            } else if (code == -1) {
              that.$toast(msg)
              // 失败
            }
          })
        }
      })
    },
    queryMemCategory() {
      var that = this
      this.memCategories = [{ value: '', label: '所有' }]
      var codelist = this.$store.getters.codelist['GOODS_MEM_TYPE']
      Object.keys(codelist).forEach(function(key) {
        that.memCategories.push({ value: key, label: codelist[key] })
      })
    },
    changeMemCategory(category) {
      this.memSelectCategory = category
      this.memSelectPackage = {}
      this.memCurrentList = []
      let _memCurrentList = []
      for (var i = 0; i < this.memGoodsList.length; i++) {
        if (
          !this.memSelectCategory.value ||
          (this.memGoodsList[i].memType &&
            this.memGoodsList[i].memType.value == this.memSelectCategory.value)
        ) {
          _memCurrentList.push(this.memGoodsList[i])
        }
      }
      this.memCurrentList = _memCurrentList
    },
    queryMemSpecs() {
      var that = this
      this.memSpecs = []
      var codelist = this.$store.getters.codelist['GOODS_MEM_SPECS']
      Object.keys(codelist).forEach(function(key) {
        that.memSpecs.push({ value: key, label: codelist[key] })
      })
    },
    changeMemSpecs(specs) {
      this.memSelectPackage = specs
      this.memCurrentList = []
      for (var i = 0; i < this.memGoodsList.length; i++) {
        if (
          !this.memSelectCategory.value ||
          (this.memGoodsList[i].hallType &&
            this.goodsList[i].hallType.value == this.memSelectCategory.value)
        ) {
          if (
            !this.memSelectPackage.value ||
            (this.memGoodsList[i].hallSpecs &&
              this.goodsList[i].hallSpecs.value == this.memSelectPackage.value)
          ) {
            this.memCurrentList.push(this.memGoodsList[i])
          }
        }
      }
    },
    queryMemGoodsAll() {
      var that = this
      this.$queryAll(
        'ProGoods',
        { channel: 'mem', sort: { orderNum: 1 } },
        ['id,proName,memType,firstPhoto,price,memSpecs,proDuration'],
        function(res) {
          if (that.type != 'siren') {
            for (var item in res.data) {
              res.data[item].price = 0
            }
          }
          that.$fill(that.memGoodsList, res.data)
          that.$fill(that.memCurrentList, res.data)
        }
      )
    },
    addMemCart(item) {
      var existFlag = false
      for (var j = 0; j < this.memGoodsCart.length; j++) {
        if (item.id == this.memGoodsCart[j]['id']) {
          existFlag = true
          break
        }
      }
      if (!existFlag) {
        this.memGoodsCart.push(item)
      }
      this.calcMemCart()
    },
    delMemCart(item) {
      for (var j = 0; j < this.memGoodsCart.length; j++) {
        if (item.id == this.memGoodsCart[j].id) {
          this.memGoodsCart.splice(j--, 1)
        }
      }
      this.calcMemCart()
    },
    calcMemCart() {
      var memGoodsSum = 0
      var memGoodsNum = 0
      for (var j = 0; j < this.memGoodsCart.length; j++) {
        memGoodsSum = memGoodsSum + this.memGoodsCart[j].price
        memGoodsNum = memGoodsNum + 1
      }
      this.memGoodsSum = memGoodsSum
      this.memGoodsNum = memGoodsNum
    },
    submitMemPay() {
      this.memForm.goodsList = []
      for (var i = 0; i < this.memGoodsCart.length; i++) {
        this.memForm.goodsList.push({
          goodsId: this.memGoodsCart[i].id,
          price: this.memGoodsCart[i].price,
          count: 1,
        })
      }
      var that = this
      this.memForm.hallId = this.id
      this.$submit('/api/order/addOrderWithMem', this.memForm, function(res) {
        if (res.code === 1) {
          var param = {
            orderNo: res.data.orderNo,
            myId: that.$store.getters.userId,
            openid: that.$store.getters.user['openid'],
          }
          pay(param, function(code, msg) {
            // 成功
            if (code == 1) {
              that.$toast('支付成功')
              that.memGoodsCart = []
              that.muyuanFlag = false
              setTimeout(() => {
                bus.$emit('memInit', '')
              }, 100)
              // 免费
            } else if (code == 2) {
              that.$toast('支付成功')
              that.memGoodsCart = []
              that.muyuanFlag = false
              setTimeout(() => {
                bus.$emit('memInit', '')
              }, 100)
            } else if (code == -1) {
              that.$toast(msg)
              // 失败
            }
          })
        }
      })
    },
    queryHallOne() {
      var that = this
      var params = this.$route.params
      var id = params['id']
      this.$queryOne(
        'HallInfo',
        { id: id },
        [
          'id,myId,category,hallCount,firstPhoto,secondPhoto,title,subtitle,content,browserCount,candleCount,hallBackground,memBackground,musicBackground',
        ],
        function(res) {
          that.$fill(that.hall, res['data'])
          that.jntTemplateId = that.hall.hallBackground - 1
          that.myTemplateId = that.hall.memBackground - 1
        }
      )
    },
    queryUsually(page) {
      if (!page) {
        page = 1
      }
      this.usually_list = []
      this.usually_selected = -1
      var that = this
      this.$queryAll(
        'HallUsually',
        { sort: { orderNum: 1 }, page: page, size: 3 },
        ['id,content'],
        function(res) {
          that.$fill(that.usually_list, res['data'])
          that.usually_total = res['total']
        }
      )
    },
    randomUsually() {
      if (this.usually_page < Math.ceil((this.usually_total * 1.0) / 3)) {
        this.usually_page++
      } else {
        this.usually_page = 1
      }
      this.queryUsually(this.usually_page)
    },
    changeUsually(index) {
      this.usually_selected = index
      this.message_form.content = this.usually_list[index].content
    },
    queryMessage() {
      var that = this
      this.$queryPage(
        '/api/hallmessage/queryMessagePage',
        {
          hallId: this.id,
          myId: that.$store.getters.userId,
          sort: { createDate: 0 },
        },
        ['id,accessType,content,myProfile.nickname,myProfile.headImgUrl,createDate'],
        function(res) {
          that.$fill(that.messageList, res['data'])
          that.message_total = res['total']
        }
      )
    },
    submitMessage() {
      var that = this
      this.$submit('HallMessage', this.message_form, function(res) {
        if (res['code'] === 1) {
          //that.messageListFlag = false
          that.$toast.success('留言成功！')
          that.messageEditFlag = false
          that.queryMessage()
          that.queryHallMessage()
        }
      })
    },
    setCategory(category) {
      this.message_form.accessType = category
    },
    goto(str) {
      this.$router.push({ path: str })
    },
    hallLook() {
      if (this.hallSelectList) {
        this.hallSelectList = false
      } else {
        this.hallSelectList = true
      }
    },
    memLook() {
      if (this.memSelectList) {
        this.memSelectList = false
      } else {
        this.memSelectList = true
      }
    },
    controlAudio() {
      let audio = this.$refs.audio1
      if (audio) {
        if (!this.isPlaying) {
          audio.play()
          this.isPlaying = true
        } else {
          audio.pause()
          this.isPlaying = false
        }
      }
    },
    back() {
      this.$router.go(-1) //返回上一层
    },
    closeHallJipin() {
      this.jipinFlag = false
    },
    closeMemJipin() {
      this.muyuanFlag = false
    },
    messageEdit() {
      this.messageListFlag = false
      this.messageEditFlag = true
    },
    messageClose(str) {
      if (str == 'list') {
        this.messageListFlag = false
      } else {
        this.messageEditFlag = false
      }
    },
    kejian() {
      if (this.viFlag) {
        this.viFlag = false
      } else {
        this.viFlag = true
      }
    },
    addFriend(hallId) {
      var that = this
      this.$submit(
        '/api/hallfriend/addFriend',
        {
          hallId: hallId,
          myId: this.$store.getters.userId,
        },
        function(res) {
          if (res.code == 1) {
            that.$toast.success('加入亲友团成功！')
            that.queryMyCollect()
          }
        }
      )
    },
    addCollect(hallId) {
      var that = this
      this.$submit(
        '/api/hallcollect/addCollect',
        {
          hallId: hallId,
          myId: this.$store.getters.userId,
        },
        function(res) {
          if (res.code == 1) {
            that.$toast.success('添加收藏成功！')
            that.queryMyCollect()
          }
        }
      )
    },
    delCollect(hallId) {
      var that = this
      this.$submit(
        '/api/hallcollect/removeCollect',
        {
          hallId: hallId,
          myId: this.$store.getters.userId,
        },
        function(res) {
          if (res.code == 1) {
            that.$toast.success('已取消收藏！')
            that.queryMyCollect()
          }
        }
      )
    },
  },
  watch: {
    activeName() {
      let _url = this.$route.fullPath
      if (this.activeName == 1 && _url.indexOf('mourn') < 0) {
        this.$router.push({
          path: '/jnt/mourn/' + this.$route.params.type + '/' + this.$route.params.id,
        })
      } else if (this.activeName == 2 && _url.indexOf('muqu') < 0) {
        this.$router.push({
          path: '/jnt/muqu/' + this.$route.params.type + '/' + this.$route.params.id,
        })
      }
    },
  },
}
</script>

<style>
.memory-head-left,
.memory-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.memory-head-left {
  left: 0;
}
.memory-head-left,
.memory-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.memory-head .left-back {
  height: 2.5rem;
  width: 2.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.memory-head .left-back .back-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/zjt.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .left-home {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-left: 10px;
}
.memory-head .left-home .home-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/tophome.png) no-repeat;
  background-size: 100% 100%;
  margin-top: -1px;
  margin-left: 1px;
}
.memory-head .center-info {
  position: fixed;
  top: 1.7rem;
  left: 7.5rem;
  z-index: 100;
  display: flex;
  display: -webkit-flex;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.center-info .family-slide .family-btn,
.center-info .follow-btn {
  padding: 0 10px;
  line-height: 2.7rem;
  color: #fff;
  text-align: center;
  border-radius: 20px !important;
}
.center-info .family-slide .family-btn {
  background: #e4803c;
  font-size: 1.09rem;
  margin-right: 1rem;
}
.center-info .follow-icon-wrap {
  display: flex;
  display: -webkit-flex;
  border-radius: 1.272rem !important;
  width: 3.6rem;
  height: 2.5rem;
}
.center-info .follow-btn,
.center-info .follow-icon-wrap {
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
}
.center-info .follow-no {
  background: url(../../assets/jnt/sc.png) no-repeat;
  background-size: 100% 100%;
}
.center-info .follow-yes {
  background: url(../../assets/jnt/sc1.png) no-repeat;
  background-size: 100% 100%;
}
.center-info .follow-icon {
  width: 20px;
  height: 20px;
}
.memory-head-right {
  right: 0;
}
.memory-head-left,
.memory-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.memory-head-left,
.memory-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.memory-head .music-wrap {
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  margin-right: 1rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.memory-head .music-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/music.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-share {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
  margin-right: 1rem;
}
.memory-head .right-menu,
.memory-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.memory-head .right-share .share-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/zf.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu,
.memory-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.memory-head .right-menu {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.memory-head .right-menu .menu-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/line3.png) no-repeat;
  background-size: 100% 100%;
}
.head-tabNav-wrap {
  position: fixed;
  top: 5.68rem;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  width: 10.91rem;
  z-index: 99;
}
.head-tabNav-wrap .tabNav-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item.active,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeBlack,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeWhite {
  opacity: 1;
  filter: alpha(opacity=100);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  background-color: #fff;
}
.head-tabNav-wrap .tabNav-con .activeBlack:after,
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 2rem;
  height: 3px;
}
.tomb-live-wrap {
  position: fixed;
  left: 0;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 100vw;
  height: 128.267vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
  z-index: -4;
}
.tomb_stone_bg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  z-index: 2;
}
.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.tomb_stone_bg .tomb_stone_wrap {
  position: fixed;
  top: 82.13vw;

  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
}
.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.tomb_stone_bg .tomb-head-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 41.598vw;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tomb_stone_bg .tomb-head-wrap img {
  width: 7.2vw;
  height: 10.12vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: middle;
  -webkit-object-fit: cover;
  object-fit: cover;
}
.tomb_stone_bg .tomb-head-wrap .head-name {
  height: 11.73vw;
  line-height: 11.73vw;
  font-size: 12px;
  color: #fff;
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  font-family: LiSu;
  font-weight: 400;
  letter-spacing: 3px;
  display: block;
  overflow: hidden;
  margin-top: 3px;
  white-space: nowrap;
}
.candle_wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 34.398vw;
}
.candle_wrap .free_wrap {
  width: 23.2vw;
  display: flex;
  justify-content: space-between;
  z-index: -2;
}
.candle_wrap .free_wrap,
.candle_wrap .out_wrap,
.tomb-live-wra .candle_wrap .center_wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -2px;
}
.candle_wrap .free_wrap .free-item {
  width: 3.61vw;
  display: block;
}
img {
  border: 0;
}
img {
  border-style: none;
}
div,
em,
i,
img,
input,
label {
  vertical-align: middle;
  font-style: normal;
}

.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.ground-bg {
  margin-top: 2vw;
  height: 101.33vw;
  background: url(../../assets/jnt/db.png) no-repeat;
  background-size: 100% 100%;
  background-position: 50%;
  z-index: -2;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap {
  width: 100%;
  background-color: #333;
  position: fixed;
  left: 0;
  bottom: 0;
  justify-content: space-between;
  padding: 1.87vw 4vw 0;
  z-index: 1000;
}
.tomb-footer-wrap .foot-item {
  width: 16.26vw;
  height: 12.79vw;
  border-top-left-radius: 4vw;
  border-top-right-radius: 4vw;
  background: linear-gradient(180deg, #5d5e60, #6d6e70);
  flex-direction: column;
  padding-top: 3px;
  color: #fff;
  font-size: 1.09rem;
  cursor: pointer;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap .special-bg {
  background: linear-gradient(180deg, #f99e29, #de5617);
}
.tomb-footer-wrap .foot-item {
  width: 16.26vw;
  height: 12.79vw;
  border-top-left-radius: 4vw;
  border-top-right-radius: 4vw;
  background: linear-gradient(180deg, #5d5e60, #6d6e70);
  flex-direction: column;
  padding-top: 3px;
  color: #fff;
  font-size: 1.09rem;
  cursor: pointer;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap .foot-item .icon-clean-stone {
  background: url(../../assets/jnt/shou.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon {
  width: 7.74vw;
  height: 7.74vw;
  display: block;
}
.tomb-footer-wrap .foot-item .icon-weed {
  background: url(../../assets/jnt/chan.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-pray-goods {
  background: url(../../assets/jnt/jp.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-knell-down {
  background: url(../../assets/jnt/gui.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-bow {
  background: url(../../assets/jnt/jug.png) no-repeat;
  background-size: 100% 100%;
}

.grass-wrap {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: 16.13vw;
  display: flex;
  justify-content: space-between;
}
.grass-wrap .grass_small1 {
  width: 4.14vw;
  height: 2.93vw;
  position: absolute;
  left: 32.27vw;
  bottom: 3.52vw;
}
.grass-wrap .grass_small2 {
  width: 5.34vw;
  height: 4.66vw;
  position: absolute;
  left: 57.87vw;
  bottom: 2.52vw;
}
.grass-wrap #grassWrap .grass-item:first-child {
  position: absolute;
  left: -1.88vw;
  bottom: 0;
}
.grass-wrap #grassWrap .grass-item {
  width: 80px;
  height: 35px;
}
.grass-wrap .grass-item img {
  width: 100%;
}
.grass-wrap #grassWrap .grass-item:nth-child(2) {
  position: absolute;
  left: 13.35vw;
  bottom: 0;
}
.grass-wrap #grassWrap .grass-item:nth-child(3) {
  position: absolute;
  left: 36vw;
  bottom: 0;
}
.grass-wrap #grassWrap .grass-item:nth-child(4) {
  position: absolute;
  left: 59.34vw;
  bottom: 0;
}
.grass-wrap #grassWrap .grass-item:nth-child(5) {
  position: absolute;
  left: 73.86vw;
  bottom: 0;
}
.box_mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: block;
  z-index: 10;
}
.memory-head .right-menu-row {
  position: absolute;
  right: 1rem;
  top: 4.2rem;
  background: #fff;
  border-radius: 0.3rem;
  min-width: 13.5rem;
  z-index: 11;
  box-shadow: 0 -1px 10px 0 rgb(51 51 51 / 14%);
  z-index: 100;
}
.memory-head .right-menu-row .menu-item {
  padding: 1.2rem;
  position: relative;
}
.memory-head .right-menu-row .menu-item .icon-pray {
  background: url(../../assets/jnt/jilu.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu-row .menu-item .icon {
  height: 1.818rem;
  width: 1.818rem;
  position: relative;
  top: -0.2rem;
  margin-right: 10px;
  display: inline-block;
}
.memory-head .right-menu-row .menu-item .txt {
  color: #333;
  font-size: 1.545rem;
}
.memory-head .right-menu-row .item-line:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #eef0f3;
  width: 100%;
  height: 1px;
}

.memory-head .right-menu-row .menu-item .icon-kefu {
  background: url(../../assets/jnt/kefu.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu-row .menu-item .icon-qa {
  background: url(../../assets/jnt/wen1.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu-row .menu-item .icon-complain {
  background: url(../../assets/jnt/tan1.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu-row:after {
  content: '';
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  right: 0.4rem;
  top: -0.6rem;
}
.icon-kefu:before {
  display: none;
}
.shareBox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 999;
  color: #fff;
}
.shareBox .arraw {
  background: url(../../assets/jnt/share2.png);
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  width: 67px;
  height: 55px;
  right: 2.5rem;
  top: 1.5rem;
  position: absolute;
}
.shareBox .tip-content {
  position: absolute;
  top: 7rem;
  font-size: 1.5rem;
  line-height: 2.2rem;
  margin: 0 4rem;
}
.shareBox .btn-close {
  position: absolute;
  bottom: 4rem;
  border-radius: 20rem;
  left: 0;
  width: 100%;
  font-size: 1.4rem;
  line-height: 3rem;
  text-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-direction: column;
  flex-direction: column;
  z-index: 101;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.shareBox .btn-close .icon-close {
  background: url(../../assets/jnt/gb.png) no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
}
.turn {
  animation: turn 5s linear infinite;
}
/* 
      turn : 定义的动画名称
      1s : 动画时间
      linear : 动画以何种运行轨迹完成一个周期
      infinite :规定动画应该无限次播放
     */
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

/* 商品 */

.mt-offcanvas.active {
  visibility: visible;
  z-index: 2000;
}

.mt-offcanvas {
  position: fixed;
  z-index: -1;
  visibility: hidden;
  margin: 0 auto;
  min-height: 1em;
  min-width: 1em;
}
.mt-offcanvas-bottom {
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
.mt-offcanvas-bottom .mt-offcanvas-inner {
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -webkit-overflow-scrolling: touch;
}
.mt-offcanvas-bottom__show .mt-offcanvas-inner,
.mt-offcanvas-center__show .mt-offcanvas-inner,
.mt-offcanvas-left__show .mt-offcanvas-inner,
.mt-offcanvas-right__show .mt-offcanvas-inner,
.mt-offcanvas-top__show .mt-offcanvas-inner {
  transform: translateZ(0) scaleX(1);
  -webkit-transform: translateZ(0) scaleX(1);
  opacity: 1;
}

.mt-offcanvas-inner {
  opacity: 0;
  transition-property: all;
  transition-duration: 0.3s;
  -webkit-transition-property: all;
  -webkit-transition-duration: 0.3s;
}

.inner-box {
  background-color: #fff;
  min-height: 100px;
  position: relative;
}
.inner-box .inner-box-txt {
  height: 4.272rem;
  line-height: 4.272rem;
  text-align: center;
  font-size: 1.454rem;
  color: #333;
  position: relative;
  background-color: #f7f7f7;
}
.inner-box-radius {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.pray_goods_box {
  width: auto;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;
}
.pray_goods_box .goods_nav {
  list-style: none;
  font-size: 1.3rem;
  margin-bottom: 1.8rem;
  background: #f7f7f7;
  width: 80px;
  box-sizing: border-box;
}
.pray_goods_box .goods_nav .swiper-wrapper {
  width: 80px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  margin: 0 auto;
}
.swiper-container-vertical > .swiper-wrapper {
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -o-transform: translate(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  -ms-transition-property: -ms-transform;
  transition-property: transform;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.pray_goods_box .goods_nav .swiper-wrapper .swiper-slide {
  height: auto;
}
.pray_goods_box .goods_nav .goods_nav_slide {
  width: auto;
  text-align: center;
  color: #666;
  position: relative;
  line-height: 45px;
  font-size: 1.272rem;
}
.swiper-slide {
  -webkit-flex-shrink: 0;
  -ms-flex: 0 0 auto;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.pray_goods_box .goods_nav .goods_nav_slide span {
  transition: all 0.3s ease;
  display: block;
}
.pray_goods_box .goods_nav .swiper-wrapper .swiper-slide {
  height: auto;
}
.pray_goods_box .goods_nav .active {
  background-color: #fff;
}
.pray_goods_box .goods_nav .goods_nav_slide {
  width: auto;
  text-align: center;
  color: #666;
  position: relative;
  line-height: 45px;
  font-size: 1.272rem;
}
.swiper-slide {
  -webkit-flex-shrink: 0;
  -ms-flex: 0 0 auto;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.pray_goods_box .goods_content {
  padding: 1.363rem 0.909rem;
  margin-bottom: 7.2rem;
  -webkit-overflow-scrolling: touch;
  flex: 1;
  background-color: #fff;
  box-sizing: border-box;
}
.scroll-auto {
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.goods_content .package_head_nav {
  box-sizing: border-box;
}
.goods_content .package_head_nav .package_head_nav-item {
  width: 30.3%;
  display: inline-block;
  font-size: 1.181rem;
  color: #666;
  text-align: center;
  margin: 0 3% 1.14rem 0;
  box-sizing: border-box;
}
.goods_content .package_head_nav .package_head_nav-item span {
  border-radius: 1.363rem;
  border: 1px solid #dadada;
  width: 100%;
  padding: 8.5px 0;
  box-sizing: border-box;
  display: inline-block;
}
.goods_content .package_head_nav .package_head_nav-item:nth-child(3) {
  margin-right: 0;
}

element.style {
}
.goods_content .package_head_nav .package_head_nav-tips {
  display: block;
  color: #666;
  font-size: 1.09rem;
  margin: 1.14rem 0 1.363rem;
}
.goods_content .package_head_nav .package_head_nav-item.active span {
  background-color: #e4803c;
  color: #fff;
  border: 1px solid #e4803c;
}
.goods_content .goods_content-item {
  width: 25%;
  display: inline-block;
  margin-bottom: 1.818rem;
  padding: 0 0.4rem;
  box-sizing: border-box;
}
.goods_content .goods_content-item .selected {
  border: 1px solid #e4803c;
}
.goods_content .goods_content-item .img {
  margin: 0 auto;
  max-width: 5.1rem;
  max-height: 5.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.5rem;
  padding: 0.3rem;
  background: #f7f7f7;
  position: relative;
  box-sizing: border-box;
}
.goods_content .goods_content-item .name {
  display: block;
  text-align: center;
  font-size: 1.272rem;
  color: #333;
  margin-top: 0.8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.goods_content .goods_content-item .charge {
  color: #e4803c;
}
.goods_content .goods_content-item .price {
  display: block;
  text-align: center;
  font-size: 1.15rem;
  margin-top: 0.4rem;
}
.goods_content .goods_content-item:nth-child(4n) {
  margin-right: 0;
}
.package_head {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5.454rem;
  padding: 1.363rem;
  box-sizing: border-box;
  border-top: 1px solid #f2f2f2;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  z-index: 1;
}
.package_head .content {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.package_head .content .del {
  color: #999;
  font-size: 1.09rem;
  text-decoration: line-through;
  display: block;
}
.package_head .content .price {
  font-size: 1.454rem;
  color: #333;
  font-weight: 500;
  display: block;
  margin-right: 1.363rem;
  margin-left: 1.181rem;
}
.package_head .content .buy-btn {
  line-height: 2.727rem;
  height: 2.727rem;
  width: 6.18rem;
  text-align: center;
  background: #e4803c;
  color: #fff;
  font-size: 1.454rem;
  border-radius: 1.818rem;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
}
.inner-box-close {
  width: 1.18rem;
  height: 1.18rem;
  background: url(../../assets/jnt/c1.png) no-repeat;
  background-size: 100% 100%;
  z-index: 11;
  display: inline-block;
  cursor: pointer;
}
.inner-box-close {
  position: absolute;
  top: 14px;
  right: 14px;
}
.inner-box-close__right {
  right: 1.5rem;
}
.mt-offcanvas.active ~ .mt-offcanvas-mask {
  visibility: visible;
  z-index: 1000;
}

.goods_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  width: 100%;
  z-index: 1;
  background: #fff;
}
.top_line {
  border-top: 1px solid #eee;
}
.goods_footer .goods_footer-row {
  position: relative;
  height: 60px;
  padding: 0.6rem 0;
  box-sizing: border-box;
}
.goods_footer .flex,
.goods_footer .goods_footer-row {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .goods_footer-row .row-left {
  width: 42%;
}
.goods_footer .flex,
.goods_footer .goods_footer-row {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .flex {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .goods_footer-row .row-left .goods-sel {
  background: #eee;
  height: 3rem;
  border-radius: 1.5rem;
  margin-left: 1.4rem;
  width: 100%;
  position: relative;
  -webkit-justify-content: left;
  justify-content: left;
}
.goods_footer .flex,
.goods_footer .goods_footer-row {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .flex {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.goods_footer .goods_footer-row .row-left .arrow-bottom:before {
  content: '';
  background: url(../../assets/jnt/xjt.png) no-repeat;
  background-size: 100% 100%;
  height: 0.6rem;
  width: 1rem;
  position: absolute;
  top: 1.28rem;
  right: 0.4rem;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.goods_footer .goods_footer-row .row-left .goods-sel .txt {
  color: #e4803c;
  position: relative;
}
.goods_footer .goods_footer-row .row-left .goods-sel .txt:before {
  content: '';
  display: inline-block;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 6px;
  width: 1.2rem;
  height: 1.2rem;
  background: url(../../assets/jnt/xz.png) no-repeat;
  background-size: 1.2rem auto;
  position: absolute;
  top: 0.2875rem;
  left: 0.6rem;
}
.goods_footer .goods_footer-row .row-left .goods-sel .txt1 {
  display: flex;
  overflow: hidden;
  -webkit-line-clamp: 1;
  height: 1.3rem;
  padding-left: 2.1rem;
  padding-right: 1.4rem;
}
.font12 {
  font-size: 1.2rem;
}
.font12 {
  font-size: 1.2rem;
}
.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.TextChangeToOneLines {
  -webkit-line-clamp: 1;
}
.goods_footer .goods_footer-row .row-left .goods-sel .txt1 .txt1-t {
  font-size: 1.1rem;
}
.goods_footer .goods_footer-row .row-right {
  position: relative;
  width: 58%;
  margin: 0 1.363rem;
}

.goods_footer .flex,
.goods_footer .goods_footer-row {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .flex {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .goods_footer-row .row-right .goods-total {
  color: #333;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  font-size: 1.454rem;
}
.goods_footer .goods_footer-row .row-right .buy-btn,
.goods_footer .goods_footer-row .row-right .goods-total {
  display: block;
}
.goods_footer .goods_footer-row .row-right .buy-btn {
  width: 68px;
  position: relative;
  z-index: 10;
  line-height: 2.727rem;
  height: 2.727rem;
  text-align: center;
  background: #e4803c;
  color: #fff;
  font-size: 1.454rem;
  border-radius: 1.818rem;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-user-select: none;
}
.goods_footer .goods_footer-row .row-right .buy-btn,
.goods_footer .goods_footer-row .row-right .goods-total {
  display: block;
}
.box_mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: block;
  z-index: 10;
}
.goods_selected_visible_menu {
  position: absolute;
  z-index: 29999;
  outline: none;
  left: 0;
  bottom: 3.3rem;
  background: #ddd;
  min-width: 15rem;
  border-radius: 0.5rem;
  padding-bottom: 1.363rem;
  box-sizing: border-box;
}
.goods_selected_visible_menu .bottom-line {
  border-bottom: 1px solid #ccc;
}
.goods_selected_visible_menu .title {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: 1rem;
  color: #333;
  text-align: center;
}
.goods_selected_visible_menu .menu-row {
  height: 12rem;
  overflow: auto;
}
ol,
ul {
  list-style: none;
}

.goods_selected_visible_menu .menu-row .item {
  -webkit-justify-content: left;
  justify-content: left;
  position: relative;
}
.goods_footer .flex,
.goods_footer .goods_footer-row {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
}
.goods_footer .flex {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.goods_selected_visible_menu .menu-row .title {
  color: #333;
  font-size: 1.3rem;
  width: 7rem;
  text-align: left;
}

.goods_selected_visible_menu .title {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: 1rem;
  color: #333;
  text-align: center;
}
.goods_selected_visible_menu .menu-row .price {
  color: #e4803c;
  font-size: 1rem;
  padding-top: 0.3rem;
  margin-left: 1;
}
.goods_selected_visible_menu .menu-row .price em {
  font-style: normal;
  font-size: 0.8rem;
}
em {
  font-style: normal;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: 400;
}
div,
em,
i,
img,
input,
label {
  vertical-align: middle;
  font-style: normal;
}
.goods_selected_visible_menu .menu-row .del {
  height: 20px;
  width: 20px;
  background: url(../../assets/jnt/c3.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 1rem;
}
.pray_msg_box .msg_top-txt {
  color: #e4803c;
  font-size: 1.6rem;
  text-align: center;
  margin-top: 2rem;
}
.pray_msg_box .msg_textarea {
  padding: 0 1.5rem;
  margin-top: 1.8rem;
}
.pray_msg_box .msg_textarea .txt {
  border: none;
  background: #eee;
  width: 100%;
  border-radius: 0.5rem;
  height: 9rem;
  padding: 1.2rem;
  font-size: 1.3rem;
  color: #999;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.pray_msg_box .msg_change {
  padding: 0 1.5rem;
  margin-top: 1.5rem;
}
.pray_msg_box .msg_change .msg_change-txt {
  color: #333;
  font-size: 1.4rem;
}
.pray_msg_box .msg_change .msg_change-btn {
  font-size: 1.2rem;
  float: right;
  color: #b16d4e;
  position: relative;
}
.pray_msg_box .msg_change .msg_change-btn:before {
  content: '';
  height: 1rem;
  width: 1rem;
  background: url(../../assets/jnt/huan.png);
  background-size: 100% 100%;
  display: block;
  position: absolute;
  left: -1.4rem;
  top: 0.25rem;
}
.pray_msg_box .msg_row {
  padding: 0 1.5rem;
  padding-top: 0.8rem;
  min-height: 14.4rem;
}
ol,
ul {
  list-style: none;
}
.pray_msg_box .msg_row .msg_row-item {
  line-height: 2rem;
  font-size: 1.3rem;
  padding: 0.8rem 2.2rem 0.7865rem 2rem;
  color: #333;
  position: relative;
}
.pray_msg_box .msg_row .icon-default:before {
  content: '';
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  background: url(../../assets/jnt/unchecked.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1rem;
  left: 0;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.pray_msg_box .msg_row .icon-selected {
  color: #b16d4e;
}
.pray_msg_box .msg_row .icon-selected:before {
  content: '';
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  background: url(../../assets/jnt/checked.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1rem;
  left: 0;
}

element.style {
}
.pray_msg_box .msg_visible {
  padding-left: 1.5rem;
  margin-top: 1rem;
  position: relative;
}
.pray_msg_box .msg_visible .msg_visible_item {
  display: inline-block;
  padding: 0.8rem 1rem;
  background: #eee;
  border-radius: 1.6rem;
}
.pray_msg_box .msg_visible .msg_visible_item .txt1 {
  color: #999;
  display: inline-block;
  position: relative;
  padding-left: 1.4rem;
}
.pray_msg_box .msg_visible .msg_visible_item .txt1:before {
  background: url(../../assets/jnt/tx.png) no-repeat;
  background-size: 100% 100%;
  content: '';
  height: 1rem;
  width: 1rem;
  position: absolute;
  top: 0.15rem;
  left: 0;
}
.pray_msg_box .msg_visible .msg_visible_item .txt2 {
  color: #1f1f21;
  display: inline-block;
  position: relative;
  margin-left: 1.4rem;
  padding-right: 1.6rem;
}
.pray_msg_box .msg_visible .msg_visible_item .arrow-top:before {
  content: '';
  background: url(../../assets/jnt/sjt.png) no-repeat;
  background-size: 100% 100%;
  height: 0.6rem;
  width: 1rem;
  position: absolute;
  top: 0.36rem;
  right: 0.1rem;
}
.box_mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: block;
  z-index: 10;
}
.msg_visible_menu {
  position: absolute;
  z-index: 29999;
  outline: none;
  left: 1.5rem;
  bottom: 3.3rem;
  background: #eee;
  min-width: 12rem;
  border-radius: 0.5rem;
}
.msg_visible_menu .bottom-line {
  border-bottom: 1px solid #ddd;
}
.msg_visible_menu .title {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: 1.45rem;
  color: #333;
}
.msg_visible_menu ul {
  margin: 0;
  padding: 0;
  clear: both;
}
ol,
ul {
  list-style: none;
}
.msg_visible_menu .item {
  position: static;
  float: none;
  padding-left: 1.45rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.msg_visible_menu .bottom-line {
  border-bottom: 1px solid #ddd;
}
.msg_visible_menu .item .icon-selected {
  height: 1.6rem;
  width: 1.6rem;
  display: inline-block;
  background: url(../../assets/jnt/xz1.png);
  background-size: 100% 100%;
}
.msg_visible_menu .item .txt {
  padding-left: 0.4rem;
}
.msg_visible_menu .item .txt .selected {
  color: #b16d4e;
}
.msg_visible_menu .item .txt .txt1 {
  color: #333;
  font-size: 1.3rem;
}
.msg_visible_menu .item .txt .txt2 {
  color: #333;
  font-size: 1rem;
  padding-top: 0.3rem;
}
.msg_visible_menu .item .icon-default {
  height: 1.6rem;
  width: 1.6rem;
  display: inline-block;
  background: url(../../assets/jnt/unchecked.png);
  background-size: 100% 100%;
}
.msg_visible_menu .item .txt {
  padding-left: 0.4rem;
}
.msg_visible_menu .item .txt .txt1 {
  color: #333;
  font-size: 1.3rem;
}
.pray_msg_box .msg_visible .msg-num {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.2rem;
  color: #999;
  padding-left: 2px;
  margin-right: 1.5rem;
  margin-top: 0.8rem;
}
.pray_msg_box .msg_footer {
  padding: 0 1.5rem;
  margin-top: 2.6rem;
  margin-bottom: 1.2rem;
}
.pray_msg_box .msg_footer .btn-submit {
  height: 4rem;
  background: #e4803c;
  width: 100%;
  border-radius: 2rem;
  text-align: center;
  line-height: 4rem;
  font-size: 1.5rem;
  color: #fff;
}
.inner-box-close {
  width: 1.18rem;
  height: 1.18rem;
  background: url(../../assets/jnt/c1.png) no-repeat;
  background-size: 100% 100%;
  z-index: 11;
  display: inline-block;
  cursor: pointer;
}
.inner-icon-close {
  height: 15px;
  width: 15px;
  background: url(../../assets/jnt/c1.png) no-repeat;
  background-size: 100%;
}
.inner-box-close {
  position: absolute;
  top: 14px;
  right: 14px;
}
.inner-box-close__right {
  right: 1.5rem;
}
.pray_msg_list_box {
  position: relative;
}
.pray_msg_list_box .top-txt {
  color: #e4803c;
  font-size: 1.6rem;
  text-align: center;
  margin-top: 2rem;
}
.pray_msg_list_box .msg_list-row {
  margin-top: 1.8rem;
  height: 22rem;
  overflow: auto;
  margin-bottom: 80px;
}
.msg_list-row .msg_list-item {
  display: -webkit-box;
  display: box;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 1.1rem;
  padding: 0 1.5rem;
}
.msg_list-row .msg_list-item .headimg {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
}
img {
  border: 0;
}
.msg_list-row .msg_list-item .info {
  margin-left: 1rem;
  margin-right: 20px;
}
.msg_list-row .msg_list-item .info .name {
  color: #666;
  font-size: 1.1rem;
}
.msg_list-row .msg_list-item .info .content {
  color: #1f1f21;
  font-size: 1.3rem;
  margin-top: 0.685rem;
  line-height: 1.6rem;
}
.msg_list-row .msg_list-item .info .time {
  color: #afafaf;
  font-size: 1rem;
  margin-top: 0.5rem;
}
.scroll-auto {
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.pray_msg_list_box .msg_list-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  width: 100%;
  height: 58px;
  padding: 0.6rem 0;
  background: #fff;
}
.pray_msg_list_box .msg_list-footer .msg-bg {
  background: #eee;
  border-radius: 3.3rem;
  padding: 0.9rem 1.5rem;
  position: relative;
  width: 62%;
  margin: 0 1.5rem;
}

element.style {
}
.pray_msg_list_box .msg_list-footer .msg-bg .txt {
  color: #999;
  position: relative;
  font-size: 1.3rem;
  padding-left: 1.95rem;
}
.pray_msg_list_box .msg_list-footer .msg-bg .icon-edit:before {
  content: '';
  background: url(../../assets/jnt/bianji.png) no-repeat;
  background-size: 100% 100%;
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0;
  left: 0;
}
.pray_msg_list_box .msg_list-footer .msg-btn {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.flex_center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
}
.pray_msg_list_box .msg_list-footer .msg-btn .txt {
  background: #e4803c;
  color: #fff;
  padding: 0.9rem 1.5rem;
  font-size: 1.3rem;
  border-radius: 3.3rem;
  display: inline-block;
}
.pray_goods_box .goods_nav .active span {
  transform: scale(1.1);
  color: #e4803c;
}
.child-item-time {
  margin-top: 5px;
  color: #999;
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  display: block;
  text-align: center;
}
.child-item-time i {
  width: 3.2vw;
  height: 3.2vw;
  display: inline-block;
  background: url(../../assets/jnt/shixiao.png) no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}
.goods_content-item img {
  width: 100%;
}
.head-tabNav-wrap .tabNav-con .activeBlack:after,
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 2rem;
  height: 3px;
}
.head-tabNav-wrap .tabNav-con .activeBlack:after {
  background-color: #000;
}
.goods_content .goods_content-item .free {
  color: #2fc653;
}

/* 分享 */
.invite-friends-pop {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
}

.invite-friends-pop .invite-friends-wrap {
  position: absolute;
  -ms-flex-align: center;
  -ms-flex-direction: column;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  top: 0;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding-top: 1.818rem;
  box-sizing: border-box;
}

.invite-friends-pop .invite-friends-wrap .share-img {
  width: 25.91rem;
  margin-bottom: 1.636rem;
}

.invite-friends-pop .invite-friends-wrap .share-btn {
  width: 22rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.invite-friends-pop .invite-friends-wrap .share-btn .share-btn-copy,
.invite-friends-pop .invite-friends-wrap .share-btn .share-btn-share {
  width: 8.64rem;
  height: 2.818rem;
  background: #fff;
  border-radius: 1.363rem;
  color: #666;
  font-size: 1.272rem;
  line-height: 2.818rem;
  text-align: center;
  cursor: pointer;
}

.invite-friends-pop .invite-friends-wrap .share-btn .icon {
  width: 1.363rem;
  height: 1.363rem;
  display: inline-block;
  margin-right: 6px;
  vertical-align: text-top;
}

.invite-friends-pop .invite-friends-wrap .share-tips {
  font-size: 1.272rem;
  color: #fff;
  text-align: center;
  margin-top: 2rem;
}

.invite-friends-pop .invite-table {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 7.27rem;
  background-color: #fff;
  z-index: 1000;
}

.invite-friends-pop .invite-table .save-text {
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
  margin-top: 0.45rem;
  margin-bottom: 0.73rem;
  text-align: center;
}

.invite-friends-pop .invite-table .invite-table-title {
  display: flex;
  justify-content: space-evenly;
}

.invite-friends-pop .invite-table .invite-table-title .title {
  width: 4.27rem;
  height: 4.27rem;
  line-height: 4.27rem;
  text-align: center;
  position: relative;
  font-size: 1.09rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #e7e7e7;
  border-radius: 2px;
}

.invite-friends-pop .invite-table .invite-table-title .title.active {
  color: #e4803c !important;
  font-size: 1.363rem;
  animation: all linear 0.3s;
  border: 1px solid #e4803c;
}

.invite-friends-pop .invite-table .invite-table-title.obituary-title .title:nth-child(2) {
  background-color: #fceab8;
}

/* 分享 */
</style>
